const FIELDS = [["name", "Alliance"], ["rank", "Rank"], ["atlantisPoints", "Atl. pts"], ["delta", "Change"], ["victoryPoints", "VP"], ["nodes", "Nodes"]];
const NUMERIC = new Set(["rank", "atlantisPoints"]);

export const BracketTable = ({ g, grp, onChange }) => {
  const set = (i, k, v) => onChange({
    ...grp,
    alliances: grp.alliances.map((a, j) => (j === i ? { ...a, [k]: NUMERIC.has(k) ? (v === "" ? null : Number(v)) : v } : a)),
  });
  return (
    <div style={{ marginTop: 12 }} data-testid={`intake-bracket-${g}`}>
      <label style={{ fontSize: 13, fontWeight: 600, display: "flex", gap: 6, marginBottom: 6 }}>
        <input type="checkbox" checked={grp.includeBracket} onChange={(e) => onChange({ ...grp, includeBracket: e.target.checked })} data-testid={`intake-bracket-${g}-include`} />
        Replace this group's bracket
      </label>
      <div className="lg-scroll">
        <table className={`lg-itable ${grp.includeBracket ? "" : "lg-off"}`}>
          <thead><tr>{FIELDS.map(([, l]) => <th key={l}>{l}</th>)}<th>Us</th><th>Ally</th></tr></thead>
          <tbody>{grp.alliances.map((a, i) => (
            <tr key={i}>
              {FIELDS.map(([k]) => <td key={k}><input className="lg-input lg-mini" value={a[k] ?? ""} onChange={(e) => set(i, k, e.target.value)} data-testid={`intake-bracket-${g}-${i}-${k}`} /></td>)}
              <td><input type="checkbox" checked={!!a.isUs} onChange={(e) => set(i, "isUs", e.target.checked)} data-testid={`intake-bracket-${g}-${i}-us`} /></td>
              <td><input type="checkbox" checked={!!a.ally} onChange={(e) => set(i, "ally", e.target.checked)} data-testid={`intake-bracket-${g}-${i}-ally`} /></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
